import { IProjectActivityHistory } from '../views/project/types/projectActivity'
import { IProjectActivity } from '../views/project/types/projectActivity'
import { HttpClient } from './service'
import Urls from './urls'

export const ActivityApi = {
  getActivity(projectId: number | string, activity: IProjectActivity): Promise<IProjectActivity> {
    return HttpClient.get<IProjectActivity, IProjectActivity>(`${Urls.Projects.projects}${projectId}/activities/${activity.id}/`)
  },

  updateActivity(projectId: number | string, activity: IProjectActivity): Promise<IProjectActivity> {
    return HttpClient.put<IProjectActivity, IProjectActivity>(`${Urls.Projects.projects}${projectId}/activities/`, activity.id, activity)
  },

  getActivityHistory(projectId: number | string, activity: IProjectActivity, search: string): Promise<IProjectActivityHistory[]> {
    return HttpClient.get<IProjectActivityHistory[], { search: string }>(`${Urls.Projects.projects}${projectId}/activities/${activity.id}/history`, { search: search })
  },

  deleteActivity(projectId: number | string, activity: IProjectActivity): Promise<string | number> {
    return HttpClient.delete<string | number, string | number>(`${Urls.Projects.projects}${projectId}/activities/`, activity.id)
  },

  createActivity(projectId: number | string, activity: IProjectActivity): Promise<IProjectActivity> {
    return HttpClient.post<IProjectActivity, IProjectActivity>(`${Urls.Projects.projects}${projectId}/activities/`, activity)
  }
}
